import callApi from './callApi';

export const fetchCustomerData = async (
  page = 1,
  perPage = 10,
  search = ''
) => {
  const url = `admin/customers?page=${page}&perPage=${perPage}&search=${search}`;
  return callApi(url, {}, 'GET');
};

export const modifyCustomerStatus = async (data) => {
  const url = `admin/customers/modify-status`;
  const body = {
    ...data,
  };

  return callApi(url, {}, 'PUT', body);
};

export const fetchDeletedCustomer = async (
  page = 1,
  perPage = 10,
  search = ''
) => {
  const url = `admin/deleted-customers?page=${page}&perPage=${perPage}&search=${search}`;

  return callApi(url, {}, 'GET');
};

export const fetchReleaseNotes = async (page = 1, perPage = 10) => {
  const url = `releases?page=${page}&perPage=${perPage}`;
  return callApi(url, {}, 'GET');
};

export const createReleaseNote = async (data) => {
  const url = `releases`;
  const headers = {
    'Content-Type': 'application/json',
  };
  return callApi(url, headers, 'POST', data);
};

export const updateReleaseNote = async (id, data) => {
  const url = `releases/update/${id}`;
  const body = {
    ...data,
  };

  return callApi(url, {}, 'PUT', body);
};

export const publishReleaseNote = async (id) => {
  const url = `releases/publish/${id}`;
  const body = {
    id,
    published: true,
  };

  return callApi(url, {}, 'PUT', body);
};


export const deleteReleaseNote = async (id) => {
  const url = `releases/${id}`;

  return callApi(url, {}, 'DELETE');
};

export const addCustomer = async (user) => {
  const url = `admin/add-customer`;
  const body = {
    user,
  };

  return callApi(url, {}, 'POST', body);
};

export const fetchErrorLogs = async (
  page = 1,
  perPage = 10,
  search = ''
) => {
  const params = new URLSearchParams({
    page: page,
    perPage: perPage,
    searchTerm: search,
  });
  const url = `logs?${params.toString()}`;
  return callApi(url, {}, 'GET');
};

export const upgradeToFreemium = async (organizationId) => {
  const url = `admin/customers/upgrade-freemium`;
  return callApi(url, {}, 'PUT', {organizationId});
};